"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fromRaw_1 = __importDefault(require("./fromRaw"));
const valueFromText = (text) => {
    return fromRaw_1.default({
        text: `[${text.replace(/\n/gi, '][')}]`,
        ranges: []
    }).value.slice(1, -1);
};
exports.default = valueFromText;
//# sourceMappingURL=valueFromText.js.map